<div class="content">
  <div class="configurationBannerHeader" (click)="toggleExpansion()">
    <label class="configurationBannerLabel">Cooling Performance</label>
    <span class="spacer"></span>
    <mat-icon class="expansionIcon">{{ getExpansionIcon() }}</mat-icon>
  </div>
  @if (isExpanded) {
    <div class="detail">
      <div class="configurationOptions">
        @if (hasMessages()) {
          <div class="performanceDetailRow">
            @for (message of results().messages; track message) {
              <div class="performance-warning">
                {{message}}
              </div>
            }
          </div>
        }
        <div class="configurationDetailRow">
          <span class="fullWidthConfigurationInput">
            <label class="halfWidthInputLabel">Total Capacity:</label>
            <label class="configuration-performance-output-label">{{results()?.totalCapacity || 0}}</label>
            <label class="units-label">MBH</label>
          </span>
        </div>
        <div class="configurationDetailRow">
          <span class="fullWidthConfigurationInput">
            <label class="halfWidthInputLabel">Entering Fluid Temperature:</label>
            <label class="configuration-performance-output-label">{{results()?.enteringWaterTemperature || 0}}</label>
            <label class="units-label">°F</label>
          </span>
        </div>
        <div class="configurationDetailRow">
          <span class="fullWidthConfigurationInput">
            <label class="halfWidthInputLabel">Fluid Flow Rate:</label>
            <label class="configuration-performance-output-label">{{results()?.fluidFlow || 0}}</label>
            <label class="units-label">GPM</label>
          </span>
        </div>
        <div class="configurationDetailRow">
          <span class="fullWidthConfigurationInput">
            <label class="halfWidthInputLabel">Heat of Rejection:</label>
            <label class="configuration-performance-output-label">{{results()?.heatOfRejection || 0}}</label>
            <label class="units-label">MBH</label>
          </span>
        </div>
        <div class="configurationDetailRow">
          <span class="fullWidthConfigurationInput">
            <label class="halfWidthInputLabel">Leaving Fluid Temperature:</label>
            <label class="configuration-performance-output-label">{{results()?.leavingWaterTemperature || 0}}</label>
            <label class="units-label">°F</label>
          </span>
        </div>
        <div class="configurationDetailRow">
          <span class="fullWidthConfigurationInput">
            <label class="halfWidthInputLabel">Power:</label>
            <label class="configuration-performance-output-label">{{results()?.powerInput || 0}}</label>
            <label class="units-label">kW</label>
          </span>
        </div>
        <div class="configurationDetailRow">
          <span class="fullWidthConfigurationInput">
            <label class="halfWidthInputLabel">Fluid Pressure Drop:</label>
            <label class="configuration-performance-output-label">{{results()?.pressureDrop || 0}}</label>
            <label class="units-label">ftWG</label>
          </span>
        </div>
        <div class="configurationDetailRow">
          <span class="fullWidthConfigurationInput">
            <label class="halfWidthInputLabel">EER:</label>
            <label class="configuration-performance-output-label">{{results()?.eer || 0}}</label>
          </span>
        </div>
        <div class="configurationDetailRow">
          <span class="fullWidthConfigurationInput">
            <label class="halfWidthInputLabel">Load Entering Fluid Temp:</label>
            <label class="configuration-performance-output-label">{{results()?.loadEnteringWaterTemperature || 0}}</label>
            <label class="units-label">°F</label>
          </span>
        </div>
        <div class="configurationDetailRow">
          <span class="fullWidthConfigurationInput">
            <label class="halfWidthInputLabel">Load Leaving Fluid Temp:</label>
            <label class="configuration-performance-output-label">{{results()?.loadLeavingWaterTemperature || 0}}</label>
            <label class="units-label">°F</label>
          </span>
        </div>
        <div class="configurationDetailRow">
          <span class="fullWidthConfigurationInput">
            <label class="halfWidthInputLabel">Load Fluid Flow Rate:</label>
            <label class="configuration-performance-output-label">{{results()?.loadFluidFlow || 0}}</label>
            <label class="units-label">GPM</label>
          </span>
        </div>
        <div class="configurationDetailRow">
          <span class="fullWidthConfigurationInput">
            <label class="halfWidthInputLabel">Load Fluid Pressure Drop:</label>
            <label class="configuration-performance-output-label">{{results()?.loadPressureDrop || 0}}</label>
            <label class="units-label">ftWG</label>
          </span>
        </div>
      </div>
    </div>
  }
</div>
